import React from 'react';
import { Link } from 'react-router-dom';

const LINK_CLASS =
  'flex-auto appearance-none border border-[#D0D0D0] rounded-[10px] bg-[#253D90] ' +
  'inline-block text-[12.5px] font-semibold leading-normal mx-[5px] min-h-[2.75em] ' +
  'outline-none px-2.5 py-2.5 text-left no-underline transition-all duration-300 ' +
  'text-[#FAFAFA] select-none touch-manipulation will-change-transform ' +
  'hover:bg-[#12186B] hover:text-[#FAFAFA]';

function NotFound() {
  return (
    <section className="block h-[80vh] bg-[#f9fafa] justify-center items-center md:flex">
      <div className="flex justify-center md:block">
        <img src={require('../img/404.png')} alt="Error 404 — página no encontrada" width={650} />
      </div>
      <div>
        <h1>Ooops...</h1>
        <h3>No se encontró la página solicitada.</h3>
        <p>Regresa a la página principal: <Link className={LINK_CLASS} to="/">Inicio</Link></p>
        <p>Explora todas las secciones: <Link className={LINK_CLASS} to="/mapa-del-sitio">Mapa del Sitio</Link></p>
        <p>Conoce nuestras herramientas de autodiagnóstico: <Link className={LINK_CLASS} to="/plans/opp">Mapa de Oportunidades</Link></p>
        <p>¿Necesitas ayuda? <a className={LINK_CLASS} href="https://web.icetex.gov.co/atencion-y-servicios-a-la-ciudadania/canales-de-atencion/canales-digitales" target="_blank" rel="noopener noreferrer">Contáctanos</a></p>
      </div>
    </section>
  );
}

export default NotFound;
